import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles<Theme>(({ palette, spacing }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(1),
    // Sits between the product line and Total Pay, so it needs air on both sides.
    margin: spacing(2, 0),
  },
  form: {
    display: 'flex',
    gap: spacing(1),
    alignItems: 'flex-start',
  },
  input: {
    flex: 1,
  },
  applyButton: {
    height: spacing(5),
    textTransform: 'none',
  },
  discountRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: spacing(2),
  },
  discountLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing(1),
  },
  removeButton: {
    minWidth: 'unset',
    padding: 0,
    marginLeft: spacing(1),
    textTransform: 'none',
  },
  error: {
    color: palette.error.main,
  },
}));
